module.exports = "/_next/static/images/favicon-b2978591e13c4da4710844d5c9808a87.ico";